import { StkCoreSavingsSm, StkCoreSavingsMd, StkCoreSavingsLg, StkCoreSavingsXl, StkEmergenciesSm, StkEmergenciesMd, StkEmergenciesLg, StkEmergenciesXl, StkHomeSm, StkHomeMd, StkHomeLg, StkHomeXl, StkVacationSm, StkVacationMd, StkVacationLg, StkVacationXl, StkOccasionsSm, StkOccasionsMd, StkOccasionsLg, StkOccasionsXl, StkEducationSm, StkEducationMd, StkEducationLg, StkEducationXl, StkFamilySm, StkFamilyMd, StkFamilyLg, StkFamilyXl, StkTaxPaymentsSm, StkTaxPaymentsMd, StkTaxPaymentsLg, StkTaxPaymentsXl, StkBillPaymentsSm, StkBillPaymentsMd, StkBillPaymentsLg, StkBillPaymentsXl, StkVehiclesSm, StkVehiclesMd, StkVehiclesLg, StkVehiclesXl, StkPetsSm, StkPetsMd, StkPetsLg, StkPetsXl, StkMakeYourOwnSm, StkMakeYourOwnMd, StkMakeYourOwnLg, StkMakeYourOwnXl, StkWeddingSm, StkWeddingMd, StkWeddingLg, StkWeddingXl, StkRetirementSm, StkRetirementMd, StkRetirementLg, StkRetirementXl, } from '@ally/ally-media';
var BucketImageMap = {
    0: {
        sm: StkCoreSavingsSm,
        md: StkCoreSavingsMd,
        lg: StkCoreSavingsLg,
        xl: StkCoreSavingsXl,
    },
    1: {
        sm: StkEmergenciesSm,
        md: StkEmergenciesMd,
        lg: StkEmergenciesLg,
        xl: StkEmergenciesXl,
    },
    2: {
        sm: StkHomeSm,
        md: StkHomeMd,
        lg: StkHomeLg,
        xl: StkHomeXl,
    },
    3: {
        sm: StkVacationSm,
        md: StkVacationMd,
        lg: StkVacationLg,
        xl: StkVacationXl,
    },
    4: {
        sm: StkOccasionsSm,
        md: StkOccasionsMd,
        lg: StkOccasionsLg,
        xl: StkOccasionsXl,
    },
    5: {
        sm: StkEducationSm,
        md: StkEducationMd,
        lg: StkEducationLg,
        xl: StkEducationXl,
    },
    6: {
        sm: StkFamilySm,
        md: StkFamilyMd,
        lg: StkFamilyLg,
        xl: StkFamilyXl,
    },
    7: {
        sm: StkTaxPaymentsSm,
        md: StkTaxPaymentsMd,
        lg: StkTaxPaymentsLg,
        xl: StkTaxPaymentsXl,
    },
    8: {
        sm: StkBillPaymentsSm,
        md: StkBillPaymentsMd,
        lg: StkBillPaymentsLg,
        xl: StkBillPaymentsXl,
    },
    9: {
        sm: StkVehiclesSm,
        md: StkVehiclesMd,
        lg: StkVehiclesLg,
        xl: StkVehiclesXl,
    },
    10: {
        sm: StkPetsSm,
        md: StkPetsMd,
        lg: StkPetsLg,
        xl: StkPetsXl,
    },
    11: {
        sm: StkMakeYourOwnSm,
        md: StkMakeYourOwnMd,
        lg: StkMakeYourOwnLg,
        xl: StkMakeYourOwnXl,
    },
    12: {
        sm: StkWeddingSm,
        md: StkWeddingMd,
        lg: StkWeddingLg,
        xl: StkWeddingXl,
    },
    13: {
        sm: StkRetirementSm,
        md: StkRetirementMd,
        lg: StkRetirementLg,
        xl: StkRetirementXl,
    },
};
export default BucketImageMap;
//# sourceMappingURL=index.js.map